export const Flag = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="189"
		height="27"
		viewBox="0 0 189 27"
		fill="none"
	>
		<path d="M-1 0L189 0L182.771 13.5L189 27L-1 27V0Z" fill="#EB5757" />
	</svg>
);
